import { groupValuesByKey } from './groupValuesByKey';

export const createDataset = () => {
  let dataset = [];
  let selections = [];

  const filter = () =>
    dataset.filter((p) =>
      selections.every((selection) => p[selection.name] === selection.value)
    );

  const calculateParameters = () => {
    const filteredDataset = filter();
    const groupedParameters = groupValuesByKey(filteredDataset);
    const lastSelection = selections[selections.length - 1];

    const parameters = Object.entries(groupedParameters).map(
      ([name, values]) => ({
        name,
        values,
        selected: Boolean(
          selections.find((s) => s.name === name && s.value === values[0])
        ),
        lastSelection: lastSelection && lastSelection.name === name,
      })
    );
    return parameters;
  };

  const updateSelections = (newSelections) => {
    selections = newSelections;
    return calculateParameters();
  };
  const getSelections = () => selections;

  const set = (data) => {
    dataset = data;
    return calculateParameters();
  };

  const select = (parameter) => {
    selections.push(parameter);
    return calculateParameters();
  };

  const reset = (parameter) => {
    selections = selections.filter((p) => p.name !== parameter.name);
    return calculateParameters();
  };

  const clear = () => {
    selections = [];
  };

  return {
    updateSelections,
    getSelections,
    set,
    select,
    reset,
    clear,
  };
};
